import "./WhoWeWorkWith.module.css";
import Header from "@/reusable_sections/Header";
import BuyersHero from "./sections/BuyersHero";
import SectorGrid from "./sections/SectorGrid";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function WhoWeWorkWithPage() {
  return <div>
      <Header />
      <BuyersHero />
      <SectorGrid />
      <Quote />
      <Footer />
    </div>;
}